import { ActionTypes } from 'modules/experiments/ducks/actionTypes';
import {
  ExperimentsTableFilterOptionPayload,
  ExperimentsTableFilterPayload,
} from 'modules/experiments/types';

export const fetchExperimentsTableFilterOptionRequest = (
  payload: ExperimentsTableFilterOptionPayload,
) => ({
  type: ActionTypes.FETCH_TABLE_FILTER_OPTION_REQUEST,
  payload,
});

export const fetchExperimentsTableFilterOptionResponse = (
  payload: ExperimentsTableFilterPayload,
) => ({
  type: ActionTypes.FETCH_TABLE_FILTER_OPTION_RESPONSE,
  payload,
});

export const fetchExperimentsTableFilterOptionError = () => ({
  type: ActionTypes.FETCH_TABLE_FILTER_OPTION_ERROR,
});
